import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, Col } from 'react-bootstrap';
import AppContext from 'context/Context';
import {
  patch,
  createNewVisit
} from 'services/salesperson-kpi/saleCustService';
import BaseDropdown from 'components/dropdowns/BaseDropdown';
import DatePicker from 'react-datepicker';
import { convertUTCDateToLocalDate } from 'helpers/dateHelper';
import moment from 'moment';

const MyVisitsModal = ({
  isShow,
  data,
  customerSource,
  handleClose,
  handleSubmit
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  useEffect(() => {
    setFormData(data);
  }, [isShow]);
  const onClose = () => {
    handleClose();
  };
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [formData, setFormData] = useState({
    visitTimeStamp: selectedDate.getTime(),
    lastVisitDate: selectedDate,
    ...data
  });

  const onSubmit = async e => {
    e.preventDefault();

    if (formData?.id > 0) {
      await patch(formData.id, { ...formData });
    } else {
      await createNewVisit({ ...formData });
    }
    handleSubmit();
  };

  const handleSelectDate = date => {
    const dayStr = moment(date).format('YYYY-MM-DD');

    const result = {
      ...formData,
      lastVisitDate: dayStr,
      visitTimeStamp: date.getTime()
    };
    setSelectedDate(date);
    setFormData(result);
  };

  const handleCustomerChange = (key, option) => {
    let newF = { ...formData, [key]: option.value };
    if (option?.orgin?.isProspect == false) {
      newF = { ...newF, visitType: 1, isProspect: false };
    } else {
      newF = { ...newF, visitType: 0, isProspect: true };
    }
    setFormData(newF);
  };
  const handleVisitTypeChange = type => {
    setFormData({ ...formData, visitType: type });
  };
  return (
    <Modal show={isShow} onHide={onClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {formData?.id > 0 ? 'Edit' : 'New'} Visit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3" controlId="titleInput">
            <Form.Label className="fs-0 required">Customer</Form.Label>
            <BaseDropdown
              sources={customerSource}
              selectedOptions={`${formData?.customerId}_${formData?.isProspect}`}
              handleChange={opts => handleCustomerChange('customerId', opts)}
              isMulti={false}
            />
          </Form.Group>
          {!formData?.isProspect && (
            <Form.Group className="mb-3" controlId="titleInput">
              <Form.Label className="fs-0 required">Visit Type</Form.Label>
              <div>
                <Form.Check
                  inline
                  label="New Customer"
                  type="radio"
                  id="newCustomer"
                  name="customerType"
                  value="1"
                  checked={formData?.visitType === 1}
                  onChange={e => handleVisitTypeChange(Number(e.target.value))}
                />
                <Form.Check
                  inline
                  label="Old Customer"
                  type="radio"
                  id="oldCustomer"
                  name="customerType"
                  value="2"
                  checked={formData?.visitType === 2}
                  onChange={e => handleVisitTypeChange(Number(e.target.value))}
                />
              </div>
            </Form.Group>
          )}
          <Col md="12">
            <Form.Label className="fs-0 required">Visit Date</Form.Label>
            <DatePicker
              selected={
                formData
                  ? convertUTCDateToLocalDate(formData.lastVisitDate)
                  : selectedDate
              }
              dateFormat="dd/MM/yyyy"
              className="form-control model-data"
              onChange={date => {
                handleSelectDate(date);
              }}
            />
          </Col>
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

MyVisitsModal.propTypes = {
  id: PropTypes.number,
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  data: PropTypes.object,
  name: PropTypes.string,
  customerSource: PropTypes.array
};

export default MyVisitsModal;
